import * as helper from './../../../Assets/Js/helper';
import {CDNHandler} from "../../../Assets/Js/CDNHandler";
import PaytourHelperClass from "../../../Assets/Js/paytour/PaytourHelperClass";

declare global {
	interface Window { paytourHelper: PaytourHelperClass; }
}

export async function PaytourHandler() {
	const $wrapper = helper.$('#wrapper');
	const extender = helper.getData($wrapper, 'extend');
	const ab1 = parseInt(helper.getData($wrapper, 'ab1'));
	const ab4 = parseInt(helper.getData($wrapper, 'ab4'));
	const ab6 = parseInt(helper.getData($wrapper, 'ab6'));
	const signupUrl = helper.getData($wrapper, 'signupurl');
	const category = helper.getData($wrapper, 'category');
	const targetUrl = helper.getData($wrapper, 'targeturl')
	const loginButton = document.querySelector('.header-buttons-login');
	const isVxWorld = window.location.host.match(/visit-x\.world/) !== null;
	const coupon = helper.getData($wrapper, 'coup');
	const cdn = new CDNHandler();
	let domain: string = await cdn.getMainDomain()

	const Paytour = window.paytourHelper;
	let PaytourSettings: any = {
		'targetUrl': '',
		'pfm': 1502,
		'host': 0,
		'hideClose': false,
		'minAmount': 2500, // cents
		'disableJump': true,
		'option': ab6 === 1 ? '5MVXSP33' : coupon,
	};

	if (category !== '') {
		PaytourSettings.conversion = {
			'signup': {
				'background': `https://${domain}/VX/Startpage/img/${category}/signupteaser_desktop.jpg`, // hier das Bild ersetzen
				'backgroundMobile': `https://${domain}/VX/Startpage/img/${category}/signupteaser_mobile.jpg` // hier das Bild ersetzen				}
			}
		}

	}

	let links;
	if (ab6 === 1) {
		links = $wrapper.querySelectorAll('.paytour, .nav a, button');
	} else if (ab4 === 0) {
		 links = $wrapper.querySelectorAll('.paytour');
	} else {
		links = $wrapper.querySelectorAll('.paytour, a, button');
	}
	links.forEach((link) => {
		if (!helper.hasClass(link, 'nopaytour')) {
			if (isVxWorld && link === loginButton) {
				helper.addClickListener(loginButton, (evt: MouseEvent) => {
					evt.preventDefault();
					window.location.href = 'https://www.visit-x.net?vxpAutoFlow=Login&' + extender;
				});
			} else {
				helper.addEventListener(link, 'click', (evt: MouseEvent) => {
					evt.preventDefault();
					if (ab1 === 3) {
						window.location = signupUrl;
					} else if (ab1 === 2) {
						window.location = targetUrl;
					} else if (ab1 === 1) {
						Paytour.openSignup(PaytourSettings);
					} else {
						Paytour.openPaytour(PaytourSettings);
					}
				})
			}
		}
	})
}
